import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { AlertTriangle, ArrowLeft } from 'lucide-react';
import { ALL_ACCOMMODATIONS, ALL_TASTING_STOPS } from '../lib/data';

export default function DraftsPage() {
  useEffect(() => {
    document.title = 'Drafts | Olive Oil Trails';
  }, []);

  const draftStops = ALL_TASTING_STOPS.filter((stop) => !stop.verified);
  const draftStays = ALL_ACCOMMODATIONS.filter((stay) => !stay.verified);

  return (
    <div className="min-h-screen bg-bg font-sans text-ink">
      <div className="bg-amber-500/10 border-b-2 border-amber-500">
        <div className="max-w-5xl mx-auto px-6 md:px-12 py-4 flex items-start gap-3">
          <AlertTriangle size={20} className="text-amber-700 mt-0.5 shrink-0" />
          <div className="text-sm text-amber-900 leading-relaxed">
            <strong>Editorial preview only.</strong> Draft entries stay unpublished until their websites,
            hours, and visitor access are rechecked against current sources.
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 py-12 md:py-16 space-y-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-ink-light hover:text-accent transition-colors"
        >
          <ArrowLeft size={14} /> Back to route
        </Link>

        <header className="space-y-4">
          <span className="pill-minimal active">Internal · Drafts</span>
          <h1 className="text-5xl md:text-6xl font-serif text-ink tracking-tight leading-[1.05]">
            Research drafts <span className="italic font-light text-accent">awaiting verification</span>
          </h1>
          <p className="text-lg text-ink-light max-w-2xl leading-relaxed">
            {draftStops.length} tasting-stop drafts and {draftStays.length} stay drafts are currently staged.
          </p>
        </header>

        {draftStops.length === 0 && draftStays.length === 0 ? (
          <div className="card-minimal p-12 bg-white/80 text-center">
            <p className="text-lg text-ink-light italic">No draft entries are currently staged.</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
